import { render, staticRenderFns } from "./DoubleCheckIcon.vue?vue&type=template&id=388b50aa&"
import script from "./DoubleCheckIcon.vue?vue&type=script&lang=ts&"
export * from "./DoubleCheckIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports